module.exports = __webpack_public_path__ + "static/media/servicebackground.6ae546f7.png";